module.exports = __webpack_public_path__ + "static/media/moveMemberIcon.ff7e8b16.svg";